import randomIntFromInterval from "../../../utils/randomIntFromInterval";

export default function SearchInputListSkeloton({ 
  count = randomIntFromInterval(6, 10),
  hash = Math.random(),
} : {
  count?: number,
  hash?: number | string,
}) {
  return (
    <div className="w-full border-0 rounded-md mx-auto">
      <div className="flex flex-wrap gap-4 animate-pulse items-center h-full">   
        {[...Array(count)].map((_, indx) => (
          <div
            key={`${hash}-${indx}`}
            className="bg-gray-300 h-12 rounded-lg"
            style={{ width: `${randomIntFromInterval(7, 20)}em` }}
          />
        ))}        
      </div>
    </div>
  );
}